import { Navigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const token = localStorage.getItem("accessToken");

  if (!token) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return children;
}